import { Directive, ElementRef, EventEmitter, OnInit, Output, inject } from '@angular/core';

@Directive({
  selector: '[appLoaded]',
})
export class LoadedDirective implements OnInit {
  private readonly element = inject(ElementRef<any>);

  @Output() loaded = new EventEmitter<ElementRef>();

  ngOnInit(): void {
    this.loaded.emit(this.element);
  }
}
